export default {"src":"/_next/static/media/ball-run.98567181.svg","height":20,"width":20};